import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=f6b44218&scoped=true&"
import script from "./Update.vue?vue&type=script&lang=babel&"
export * from "./Update.vue?vue&type=script&lang=babel&"
import style0 from "./Update.vue?vue&type=style&index=0&id=f6b44218&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b44218",
  null
  
)

export default component.exports